import React from 'react'
import classNames from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'

import { ImgSanity } from '@slite/components'

import { WebsiteCard } from '../../components/Card/Card'
import { WebsiteText } from '../../components/WebsiteText'
import { useRoutes } from '../../routes'
import type { IntegrationListingItem } from './listingQuery'

export function IntegrationGrid({
  integrations,
  columns = 3,
}: {
  integrations: IntegrationListingItem[]
  columns?: 2 | 3
}) {
  const intl = useIntl()
  const routes = useRoutes()

  if (integrations.length === 0) {
    return (
      <div className="grid-12 grid-gap-20 grid-gap-12-small">
        <div className="grid-span-12 text-align-center padding-vertical-48">
          <WebsiteText variant="body" className="shade-20">
            <FormattedMessage
              id="integrations.bucket.no-results"
              defaultMessage="No integrations in this bucket yet."
            />
          </WebsiteText>
        </div>
      </div>
    )
  }

  const cardSpan = columns === 2 ? 'grid-span-6' : 'grid-span-4'

  return (
    <div className="grid-12 grid-gap-20 grid-gap-12-small">
      {integrations.map((integration) => (
        <WebsiteCard
          href={routes.integrations.detail({
            slug: integration.slug.current,
          })}
          hoverOutline={false}
          className={classNames(
            cardSpan,
            'padding-horizontal-20 padding-vertical-24 grid-span-12-small grid-span-6-medium border-small border-alpha-shade-40 border-shade-05-on-hover'
          )}
          key={integration._id}
        >
          <div>
            <ImgSanity
              style={{ width: 40 }}
              className="radius-larger margin-bottom-8"
              src={integration.logo.url}
              alt={intl.formatMessage(
                {
                  id: 'integrations.page.integrationLogoAlt',
                  defaultMessage: '{integrationName} logo',
                },
                { integrationName: integration.name }
              )}
            />
            <h3 className="font-family-title font-weight-medium font-size-3 margin-bottom-4 shade-05">
              {integration.name}
            </h3>
            <WebsiteText variant="body" className="shade-20">
              {integration.articleDescription}
            </WebsiteText>
          </div>
        </WebsiteCard>
      ))}
    </div>
  )
}
